import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { formatCustRight } from '@core/_utils/tools.utils';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-add-custrights',
    templateUrl: './add-custrights.component.html',
    styleUrls: ['./add-custrights.component.scss'],
})
export class AddCustRightsComponent implements OnInit {

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public screenList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;

    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        ) {
        }

    ngOnInit() {
    }

    public async validate(aData) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        aData.entete.id = 0;
        const wdata = formatCustRight(aData);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('setcustomright', wdata ));
            this.onValidate.emit({ data: wRes.data });
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));	
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
